import { axios } from "../lib";
import * as endpoints from "./apiEndpoints";

class ExportService {
  static performExport(payload) {
    const url = `${endpoints.BASE_URL}${endpoints.EXPORT}`;
    return axios
      .post(url, payload, { responseType: "blob" })
      .then((response) => response.data);
  }
}

export default ExportService;
